/**
 * One place for DoughBro's Pro price, currency and trial length.
 *
 * The RevenueCat offering is the authority for what a customer is actually
 * charged — a package's `priceText` is localised and reflects whatever the
 * store has. These constants are the fallback for screens that render before
 * an offering has loaded, and for copy that has to name the price in a
 * sentence.
 */
export const PRO_PRICE_TEXT = "$1.99";

/** ISO code for the price above. Stated in the UI so the amount is unambiguous. */
export const PRO_PRICE_CURRENCY = "USD";

/** Length of the introductory free trial, configured on the store product. */
export const PRO_TRIAL_DAYS = 14;

/** "$1.99/month" — the price as it reads mid-sentence. */
export const PRO_PRICE_PER_MONTH = `${PRO_PRICE_TEXT}/month`;

/** "14 days free, then $1.99/month" */
export const PRO_TRIAL_SUMMARY = `${PRO_TRIAL_DAYS} days free, then ${PRO_PRICE_PER_MONTH}`;

/**
 * Resolve the price to show, preferring what the store actually reports.
 *
 * @param offeringPriceText `priceText` from the active RevenueCat package.
 */
export function proPriceText(offeringPriceText?: string | null) {
  return offeringPriceText?.trim() || PRO_PRICE_TEXT;
}

/** As above, suffixed with "/month". */
export function proPricePerMonth(offeringPriceText?: string | null) {
  return `${proPriceText(offeringPriceText)}/month`;
}
